export const alphabetStandardLowercase = "abcdefghijklmnopqrstuvwxyz";
//# sourceMappingURL=alphabetStandardLowercase.js.map